import http from 'hub-http/clients/apiClient';
import { createRpcClientV1 } from 'rpc-client-utils';
export const chirpClient = createRpcClientV1({
  hubHttpClient: http
});